import { isEmpty } from '@utils/common';
import { parseStringToDateInMilliseconds } from '@utils/kpi-utils/date';

import { IPortalLinkedTask } from '@interfaces/portal/tasks';

import {
	defaultDayDisabledText,
	finishToFinishDisableText,
	finishToStartPredecessorDisableText,
	finishToStartSuccessorDisableText,
	startToFinishPredecessorDisableText,
	startToFinishSuccessorDisableText,
	startToStartDisableText,
} from './constants';
import { taskLinkTypesNames } from '@components/ModalComponents/TaskForm/LinkTasksForm/constants';

export const getMaxDateStartDate = (linkedTasks: IPortalLinkedTask[]) => {
	const startToStartMaxDates = linkedTasks.filter(task => {
		return task.type.name === taskLinkTypesNames.startToStart && !task.isPredecessor && task?.startDate;
	}).map(task => parseStringToDateInMilliseconds(task.startDate!));

	const startToFinishMaxDates = linkedTasks.filter(task => {
		return task.type.name === taskLinkTypesNames.startToFinish && !task.isPredecessor && task?.endDate;
	}).map(task => parseStringToDateInMilliseconds(task.endDate!));

	const maxDates = [...startToStartMaxDates, ...startToFinishMaxDates]
		.filter((date): date is number => !!date);

	return !isEmpty(maxDates) ? Math.min(...maxDates) : undefined;
};

export const getMinDateStartDate = (linkedTasks: IPortalLinkedTask[]) => {
	const finishToStartMinDates = linkedTasks.filter(task => {
		return task.type.name === taskLinkTypesNames.finishToStart && task.isPredecessor && task?.endDate;
	}).map(task => parseStringToDateInMilliseconds(task.endDate!));

	const startToStartMinDates = linkedTasks.filter(task => {
		return task.type.name === taskLinkTypesNames.startToStart && task.isPredecessor && task?.startDate;
	}).map(task => parseStringToDateInMilliseconds(task.startDate!));

	const minDates = [...finishToStartMinDates, ...startToStartMinDates]
		.filter((date): date is number => !!date);

	return !isEmpty(minDates) ? Math.max(...minDates) : undefined;
};

export const getMaxDateEndDate = (linkedTasks: IPortalLinkedTask[]) => {
	const finishToStartMaxDates = linkedTasks.filter(task => {
		return task.type.name === taskLinkTypesNames.finishToStart && !task.isPredecessor && task?.startDate;
	}).map(task => parseStringToDateInMilliseconds(task.startDate!));

	const finishToFinishMaxDates = linkedTasks.filter(task => {
		return task.type.name === taskLinkTypesNames.finishToFinish && !task.isPredecessor && task?.endDate;
	}).map(task => parseStringToDateInMilliseconds(task.endDate!));

	const maxDates = [...finishToStartMaxDates, ...finishToFinishMaxDates]
		.filter((date): date is number => !!date);

	return !isEmpty(maxDates) ? Math.min(...maxDates) : undefined;
};

export const getMinDateEndDate = (linkedTasks: IPortalLinkedTask[]) => {
	const finishToFinishMinDates = linkedTasks.filter(task => {
		return task.type.name === taskLinkTypesNames.finishToFinish && task.isPredecessor && task?.endDate;
	}).map(task => parseStringToDateInMilliseconds(task.endDate!));

	const startToFinishMinDates = linkedTasks.filter(task => {
		return task.type.name === taskLinkTypesNames.startToFinish && task.isPredecessor && task?.startDate;
	}).map(task => parseStringToDateInMilliseconds(task.startDate!));

	const minDates = [...finishToFinishMinDates, ...startToFinishMinDates]
		.filter((date): date is number => !!date);

	return !isEmpty(minDates) ? Math.max(...minDates) : undefined;
};

export const getTooltipForDisabledDay = (linkedTasks: IPortalLinkedTask[]) => {
	if (isEmpty(linkedTasks)) return '';

	const { type: firstType, isPredecessor: firstIsPredecessor } = linkedTasks[0];

	const isOnlyOneType = linkedTasks.every(task => {
		return task.type.name === firstType.name && task.isPredecessor === firstIsPredecessor;
	});

	if (!isOnlyOneType) return defaultDayDisabledText;

	switch (true) {
		case firstType.name === taskLinkTypesNames.finishToStart && firstIsPredecessor:
			return finishToStartPredecessorDisableText;

		case firstType.name === taskLinkTypesNames.finishToStart && !firstIsPredecessor:
			return finishToStartSuccessorDisableText;

		case firstType.name === taskLinkTypesNames.startToStart:
			return startToStartDisableText;

		case firstType.name === taskLinkTypesNames.finishToFinish:
			return finishToFinishDisableText;

		case firstType.name === taskLinkTypesNames.startToFinish && firstIsPredecessor:
			return startToFinishPredecessorDisableText;

		case firstType.name === taskLinkTypesNames.startToFinish && !firstIsPredecessor:
			return startToFinishSuccessorDisableText;

		default:
			return defaultDayDisabledText;
	}
};
